import React, { useState } from 'react';

import { Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import LoginEmailForm from 'containers/LoginPage/components/LoginEmailForm';
import LoginPageSubtitle from 'containers/LoginPage/components/LoginPageSubtitle';
import LoginContainerWithBackButton from 'containers/LoginPage/containers/LoginContainerWithBackButton';
import { setGlobalMessage } from 'containers/MessageHandler/actions';
import useGlobalErrorHandler from 'hooks/useGlobalErrorHandler';
import { useResetPasswordMutation } from 'redux/api/user.api';
import globalMessages from 'translations/messages/global-messages';

const LoginForgotPassword = ({ email: initialEmail, onBackButtonClick }) => {
  const intl = useIntl();
  const [emailSent, setEmailSent] = useState(false);
  const dispatch = useDispatch();
  const dispatchGlobalError = useGlobalErrorHandler();
  const [resetPassword, { isLoading }] = useResetPasswordMutation();

  const handleSubmit = async email => {
    try {
      setEmailSent(false);
      await resetPassword({ email }).unwrap();
      dispatch(
        setGlobalMessage({
          type: 'success',
          intlMessage: { id: 'reset_password_text' },
          active: true,
        }),
      );
      setEmailSent(true);
    } catch (err) {
      dispatchGlobalError({ error: err });
    }
  };

  return (
    <LoginContainerWithBackButton onBackButtonClick={onBackButtonClick}>
      <Typography variant="header" component="p">
        {intl.formatMessage(globalMessages.forgot_password)}
      </Typography>
      <LoginPageSubtitle className="login-forgot-password-description">
        {intl.formatMessage(globalMessages.forgot_password_description)}
      </LoginPageSubtitle>
      <LoginEmailForm
        initialValue={initialEmail}
        text={emailSent ? intl.formatMessage(globalMessages.email_sent) : ''}
        loading={isLoading}
        submitLabel={intl.formatMessage(
          emailSent ? globalMessages.resend_the_email : globalMessages.continue,
        )}
        onSubmit={handleSubmit}
      />
    </LoginContainerWithBackButton>
  );
};

LoginForgotPassword.propTypes = {
  email: PropTypes.string.isRequired,
  onBackButtonClick: PropTypes.func.isRequired,
};

export default LoginForgotPassword;
